import { NameId } from "@common/types/NameId";

enum SourceEnum {
  RightRide = 1,
  Kijiji = 2,
  AutoCanadaDigital = 3,
  ACDealer = 4,
  Throttle = 5,
  Roadwise = 6,
}

export const sources: NameId[] = [
  {
    name: "RightRide",
    id: SourceEnum.RightRide.toString(),
  },
  {
    name: "Kijiji",
    id: SourceEnum.Kijiji.toString(),
  },
  {
    name: "AutoCanada Digital",
    id: SourceEnum.AutoCanadaDigital.toString(),
  },
  {
    name: "AC-Dealer",
    id: SourceEnum.ACDealer.toString(),
  },
  {
    name: "Throttle",
    id: SourceEnum.Throttle.toString(),
  },
  {
    name: "Roadwise",
    id: SourceEnum.Roadwise.toString(),
  },
].sort((a, b) => a.name.localeCompare(b.name));

export default SourceEnum;
